import { Component, OnInit, ElementRef  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReactiveFormsModule,FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Enquiry, GlobalValidator } from '../model';
import { OperationResult } from '../operationResult';
import { EnquiryService } from '../api.service';
import { DataService } from '../api.data.service';
import { ToasterService, ToasterConfig } from 'angular2-toaster/angular2-toaster';

@Component({
    selector: 'contactus',
    template: require('./contactus.component.html'),
    styles: require['./contactus.css', './toaster.css'],
    providers: [EnquiryService, DataService],
     
})
export class ContactUsComponent implements OnInit {

    enquiryForm: FormGroup;
    captchaResponse: string;
    id: number;
    loadingSubmit: boolean;

    private _Enquiry: Enquiry;
    private toasterService: ToasterService;
    public toasterconfig: ToasterConfig =
    new ToasterConfig({
        limit: 5,
        showCloseButton: true,
        tapToDismiss: false
    });

    constructor(toasterService: ToasterService, private builder: FormBuilder, public _EnquiryService: EnquiryService,
        public _Router: Router, public activatedRoute: ActivatedRoute) {

        this.toasterService = toasterService; 
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.id = +params['id']; // (+) converts string 'id' to a number
        });

        this._Enquiry = new Enquiry('', '', '', '', '', '', false, false, false, false, false,false, '', '');
        this.buildForm();
    }

    resolved(captchaResponse: string) {
        //console.log(`Resolved captcha with response ${captchaResponse}:`);
        this.captchaResponse = captchaResponse;
    }

    buildForm(): void {
        this.enquiryForm = this.builder.group({
            'name': [this._Enquiry.Name, [Validators.required]],
            'email': [this._Enquiry.Email, [Validators.required, GlobalValidator.validateEmail]],
            'phone': [this._Enquiry.Phone, [Validators.required]],
            'company': [this._Enquiry.Company],
            'jobTitle': [this._Enquiry.JobTitle],  
            'subject': [this._Enquiry.Subject, [Validators.required]],
            'body': [this._Enquiry.Body],

            'finesseSelected': (this.id === 2),
            'fiscalSelected': (this.id === 4),
            'portalSelected': (this.id === 3),
            'serviceSelected': (this.id === 5),
            'otherSelected': (this.id === 6)
        });

        this.enquiryForm.valueChanges
            .subscribe(data => this.onValueChanged(data));
        this.onValueChanged(); // (re)set validation messages now
    }

    onValueChanged(data?: any) {
        if (!this.enquiryForm) { return; }
        const form = this.enquiryForm;
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }
    formErrors = {
        'name': '',
        'email': '',
        'phone': '',
        'subject': '',
    };
    validationMessages = {
        'name': {
            'required': 'Name is required.',
        },
        'email': {
            'required': 'email is required.',
            'validateEmail': 'email address must contain @'
        },
        'phone': {
            'required': 'Phone is required.',

        },
        'subject': {
            'required': 'subject is required.',
        }
    };


    reset(): void {
        this._Enquiry = new Enquiry('', '', '', '', '', '', false, false, false, false, false, false, '', '');
        this.buildForm();
    }

    contactus(): void {
        if (!this.captchaResponse) {
            this.toasterService.pop('error', 'Sorry', 'Please verify you are not a robot by completing the reCAPTCHA.');
            return;
        }

        this.loadingSubmit = true;
        this._Enquiry = this.enquiryForm.value;
        this._Enquiry.Captcha = this.captchaResponse;

        var _OperationResult: OperationResult = new OperationResult(false, '');
        this._EnquiryService.contactus(this._Enquiry)
            .subscribe(res => {
                this.loadingSubmit = false;
                _OperationResult.Succeeded = res.succeeded;
                _OperationResult.Message = res.message;
            },
            error => {
                this.loadingSubmit = false;
                this.toasterService.pop('error', 'Sorry', 'Your enquiry has not been sent due to ' + error);
                console.error('Error:' + error)
            },
            () => {
                this.loadingSubmit = false;
                if (_OperationResult.Succeeded) {
                    this.toasterService.pop('success', 'Thank you', 'Your enquiry has been sent.');
                    this._Router.navigate(['/about']);
                } else {
                    this.toasterService.pop('error', 'Sorry', 'Your enquiry has not been sent due to ' + _OperationResult.Message);
                }
            });
    }

    private onDrop(args) {
        let [e, el] = args;
        // do something
        var rect = document.getElementById(e.id).getBoundingClientRect();

        console.log(rect.top, rect.right, rect.bottom, rect.left);

        console.log("top style " + document.getElementById(e.id).attributes[0]);

        var elm = document.getElementById('1');

        var position = getPosition(elm);

        console.log(position.x, position.y);
        
        //rct.top = 421.5;
        //rct.bottom = 441.5;
        //rct.right = 794;
        //rct.left = 74;
        elm.style.position = 'relative';
        elm.style.left = position.x + 100 + 'px';
        elm.style.left = position.y + 200 + 'px';
    }    
}

function getPosition(el) {
    var xPos = 0;
    var yPos = 0;

    while (el) {
        if (el.tagName == "BODY") {
            // deal with browser quirks with body/window/document and page scroll
            var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
            var yScroll = el.scrollTop || document.documentElement.scrollTop;

            xPos += (el.offsetLeft - xScroll + el.clientLeft);
            yPos += (el.offsetTop - yScroll + el.clientTop);
        } else {
            // for all other non-BODY elements
            xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
            yPos += (el.offsetTop - el.scrollTop + el.clientTop);
        }

        el = el.offsetParent;
    }
    return {
        x: xPos,
        y: yPos
    };
}


/** WEBPACK FOOTER **
 ** ./src/app/contactus/contactus.component.ts
 **/